import { MatDateFormats } from '@angular/material/core';

export class CustomDateFormat {
    public value: MatDateFormats;
    public get parse(): unknown {
        return this.value.parse;
    }
    public get display(): unknown {
        return this.value.display;
    }
}
